module.exports = __webpack_public_path__ + "static/media/EPS3.e7147046.png";